import { useState, useEffect, useMemo } from "react";
import { useMatch } from "react-router-dom";

import { ImageAmbientProvider } from "./ImageAmbientContext";
import ImageAmbientDialogClasses from "./ImageAmbientDialogClasses";
import ImageAmbientCount from './ImageAmbientCount'
import { useViewImageContext } from "../Images/ViewImageContext";
import { useViewLandContext } from "../ViewLandContext";
import ImageAmbientModal from "./ImageAmbientModal";
import { isImageAmbientSourceType } from "../Images/imageTypeUtils";

const ImageAmbient = ({ open, setOpen, ambient }) => {
    const [ countClasses, setCountClasses ] = useState(2);
    const [ nextStep, setNextStep ] = useState(false);
    const viewImageContext = useViewImageContext();
    const viewLandContext = useViewLandContext();
    const landId = viewLandContext.land?.land_id;
    const hasEvi = useMemo(() => {
        const activeLandImage = viewImageContext.getActiveLandImage(landId);

        if (!activeLandImage.land) {
            return false;
        }

        return isImageAmbientSourceType(activeLandImage.imageType);
    }, [landId, viewImageContext]);
    const isAmbientActive = useMatch('/gis/field/view/:field_id/land/view/:land_id/ambients');
    const hasAmbient = useMemo(() => !(ambient == null || Object.keys(ambient).length === 0), [ambient]);
    const mustShow = useMemo(() => {
        if (landId === null || landId === undefined) {
            return false;
        }

        return hasAmbient || hasEvi;
    }, [hasAmbient, hasEvi, landId]);

    useEffect(() => {
        if (isAmbientActive && ambient && open) {
            setCountClasses(ambient.params?.breaks ?? 2);
            setNextStep(true);
        } else {
            setCountClasses(2);
            setNextStep(false);
        }
    }, [ambient, isAmbientActive, open]);

    if (!mustShow)  {
        return (
            <></>
        );
    }
    return (
        <>
            <ImageAmbientProvider>
                <ImageAmbientModal open={open} setOpen={setOpen}>
                    {nextStep && (
                        <ImageAmbientDialogClasses setNextStep={setNextStep} hasEvi={hasEvi} open={open} setOpen={setOpen} numClasses={countClasses} ambient={ambient} />
                    )}
                    {!nextStep && (
                        <ImageAmbientCount setNextStep={setNextStep} open={open} setOpen={setOpen} setCountClasses={setCountClasses} />
                    )}
                </ImageAmbientModal>
            </ImageAmbientProvider>
        </>
    )
};

export default ImageAmbient;
